<template>
      <v-card class="mx-auto" shaped elevation="7" min-height="700px">
            <v-card-title>
                  Liquidación Comisión Prima
            </v-card-title>
            <v-card-text>
                  <v-container fluid grid-list-md>
                        <v-row dense>
                              <v-col cols="12" sm="6">
                                    <v-form ref="form">
                                          <v-autocomplete label="N° Liquidación *" color="textbox"
                                                v-model="obSearch.idSecLiquidacionCab" :items="listGeneral.listLiquidacion"
                                                outlined dense :rules="requeridoRegla"
                                          />
                                    </v-form>
                              </v-col>
                              <v-col cols="12" sm="3">
                                    <v-tooltip top color="primary">
                                          <template v-slot:activator="{ on }">
                                                <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                                      :disabled="disabled">
                                                      <v-icon dark>search</v-icon>
                                                </v-btn>
                                          </template>
                                          <span>Buscar</span>
                                    </v-tooltip>
                              </v-col>
                              <v-col cols="12" sm="3"></v-col>
                        </v-row>

                        <v-row dense>
                              <v-col cols="12" sm="6">
                                    <v-btn v-show="_.size(selectedTasks) > 0" rounded dark color="primary" @click="onInsertar">Liquidar</v-btn>
                              </v-col>
                              <v-col cols="12" sm="6">
                                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                          dense prepend-inner-icon="search" />
                              </v-col>
                        </v-row>
                        <v-row dense>
                              <v-col cols="12">
                                    <v-data-table v-model="selectedTasks" :search="obSearch.search" :headers="listGeneral.cabecera"
                                          :items="listGeneral.detalle" show-select
                                          item-key="idSecPrima" class="elevation-3">

                                           <template v-slot:item.primaNeta="{ item }">
                                                {{ (_.toNumber(item.idTipoMovimiento) != _.toNumber(parametros.id_tipo_movimiento_exclusion) &&
                                                    _.toNumber(item.idTipoMovimiento) != _.toNumber(parametros.id_tipo_movimiento_cancelacion)) ? item.primaNeta : `- ${item.primaNeta}` }}
                                          </template>

                                           <template v-slot:item.comision="{ item }">
                                                {{ (  _.toNumber(item.idTipoMovimiento) != _.toNumber(parametros.id_tipo_movimiento_exclusion) && 
                                                      _.toNumber(item.idTipoMovimiento) != _.toNumber(parametros.id_tipo_movimiento_cancelacion)) ? item.comision : `- ${item.comision}` }}
                                          </template>

                                           <template v-slot:item.beneficio="{ item }">
                                                {{ (  _.toNumber(item.idTipoMovimiento) != _.toNumber(parametros.id_tipo_movimiento_exclusion) && 
                                                      _.toNumber(item.idTipoMovimiento) != _.toNumber(parametros.id_tipo_movimiento_cancelacion)) ? item.beneficio : `- ${item.beneficio}` }}
                                          </template>

                                          <template v-slot:body.append>
                                                <tr v-show="_.size(listGeneral.detalle) > 0">
                                                      <td colspan="13"></td>
                                                      <td>
                                                            <span class="font-weight-black" v-html="`$${Number.parseFloat(totalPrimaNeta).toFixed(2) }`"></span>
                                                      </td>
                                                      <td></td>
                                                      <td>
                                                            <span class="font-weight-black" v-html="`$${Number.parseFloat(totalComision).toFixed(2) }`"></span>
                                                      </td>
                                                      <td></td>
                                                      <td>
                                                            <span class="font-weight-black" v-html="`$${Number.parseFloat(totalBeneficio).toFixed(2) }`"></span>
                                                      </td>
                                                </tr>
                                          </template>
                                          <template v-slot:no-results>
                                                Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó
                                                resultados.
                                          </template>
                                    </v-data-table>
                              </v-col>
                        </v-row>
                  </v-container>
            </v-card-text>
      </v-card>
</template>

<script>
      export default {
            name: 'LiquidacionComisionView',
            data: () => ({
                  obSearch: {
                        search: '',
                        idSecLiquidacionCab:null,
                  },
                  listGeneral: {},
                  parametros: {},
                  disabled: false,
                  selectedTasks:[]
            }),
            created() {
                  var error = 'E';

                  axios.post(`${BASE_URI}administrador/liquidacion-comision/cargaGeneralLiquicionComision`)
                        .then((r) => {
                              if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                              if (_.size(_.get(r, ['data', 'data'], [])) == 0) {error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion);}
                                    this.$set(this, 'listGeneral', r.data.data.listas);
                                    this.$set(this, 'parametros', r.data.data.parametros);
                                    if(_.size(this.listGeneral.listLiquidacion) == 0) { error='I'; throw mensajeEstandar.datosNulos;}
                                          this.obSearch.idSecLiquidacionCab = this.listGeneral.listLiquidacion[0].value;
                                          return this.onListar('L');
                        })
                        .catch((e) => {
                              mensajesAlerta(e, error);
                        })
            },
            computed:{
                  listaIngreso(){
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalle',[]));
                        return _.filter(l,(vv)=>{ return  _.toNumber(vv.idTipoMovimiento) != _.toNumber(this.parametros.id_tipo_movimiento_exclusion) && 
                                                            _.toNumber(vv.idTipoMovimiento) != _.toNumber(this.parametros.id_tipo_movimiento_cancelacion)
                                                });
                  },
                  listaEgreso(){
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalle',[]));
                        return _.filter(l,(vv)=>{ return _.toNumber(vv.idTipoMovimiento) == _.toNumber(this.parametros.id_tipo_movimiento_exclusion) || 
                                                         _.toNumber(vv.idTipoMovimiento) == _.toNumber(this.parametros.id_tipo_movimiento_cancelacion)
                                                });
                  },
                  totalPrimaNeta(){
                        var ing = _.sumBy(this.listaIngreso,(v)=>{ return _.toNumber(v.primaNeta); });
                        var egr = _.sumBy(this.listaEgreso,(v)=>{ return _.toNumber(v.primaNeta); });
                        return ing - egr;
                  },  
                  totalComision(){
                        var ing = _.sumBy(this.listaIngreso,(v)=>{ return _.toNumber(v.comision); });
                        var egr = _.sumBy(this.listaEgreso,(v)=>{ return _.toNumber(v.comision); });
                        return ing - egr;
                  },  
                  totalBeneficio(){
                        var ing = _.sumBy(this.listaIngreso,(v)=>{ return _.toNumber(v.beneficio); });
                        var egr = _.sumBy(this.listaEgreso,(v)=>{ return _.toNumber(v.beneficio); });
                        return ing - egr;
                  },  
            },
            methods: {
                  onListar(ev) {
                        if (!_.isUndefined(ev)) {
                              try {
                                    this.disabled = true;
                                    if (_.size(this.obSearch.idSecLiquidacionCab) == 0) throw mensajeEstandar.corregirInformacion;
                                    var error = 'E';
                                    var o = _.merge({
                                                opcion: 'LISTAR_LIQ_CAL'
                                          },
                                          _.pick(this.obSearch, ['idSecLiquidacionCab']),
                                    );

                                    this.listGeneral.detalle = [];
                                    this.selectedTasks = [];
                                    axios.post(`${BASE_URI}administrador/liquidacion-comision/listar`, o)
                                          .then((r) => {
                                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                                      var l = _.cloneDeep(r.data.data);
                                                      l = _.map(l,(v,k)=>{
                                                            v.n = k + 1;
                                                            v.comisionCobrada = 'S';
                                                            v.primaNeta = Number.parseFloat(_.round(v.primaNeta,2)).toFixed(2);
                                                            v.comision  = Number.parseFloat(_.round(v.comision,2)).toFixed(2);
                                                            v.beneficio = Number.parseFloat(_.round(v.beneficio,2)).toFixed(2);

                                                            return v;
                                                      });
                                                      this.listGeneral.detalle = l;
                                                      this.disabled = false;
                                          })
                                          .catch((e) => {
                                                mensajesAlerta(e, error);
                                                this.disabled = false;
                                          });
                              } catch (ex) {
                                    mensajesAlerta(ex, 'I');
                                    this.disabled = false;
                              }
                        }
                  },
                  onInsertar(ev){
                      if (!_.isUndefined(ev)) {
                            this.disabled = true;
                            var error = 'E';
                            var k = [ 'idSecLiquidacionDet','idProducto','comisionCobrada','idSecPrima','impuestos','primaBruta','primaNeta' ];
                            var l = _.cloneDeep(this.selectedTasks);
                            var o = _.merge(
                                                { opcion:'UC','totalComision':_.sumBy(l,(v)=>{ return _.toNumber(v.comision); })},
                                                _.pick(this.obSearch,'idSecLiquidacionCab'),
                                                {
                                                      idEstadoLiquidacion:this.parametros.id_tipo_estado_liquidacion_liquidada,
                                                      listDetalle:_.map(l,_.partialRight(_.pick,k))
                                                }
                                    );

                            axios.post(`${BASE_URI}administrador/liquidacion-comision/insertOrUpdateComision`,o)
                                 .then((r) => {
                                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }

                                                      mensajeAlertaTiempo('Registros Procesados con exito.','S')
                                                      this.disabled = false;
                                                      this.selectedTasks = [];
                                                      this.onListar('L');
                                          })
                                          .catch((e) => {
                                                mensajesAlerta(e, error);
                                                this.disabled = false;
                                          });
                      }       
                  }
            }
      }
</script>